
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/gaming-parlor",
      function () {
        return require("private-next-pages/outlet/gaming-parlor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/gaming-parlor"])
      });
    }
  